import { updateBook } from "../actions";

const update = (book) => async (dispatch) => {
  const response = await fetch(`http://localhost:9000/books/${book.id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(book),
  });
  const updatedBook = await response.json();
  dispatch(updateBook(updatedBook));
};

export default update;
